(function() {
    var MKTF30021_tmpl =
    '{{#each item, index in questionList}}' +
        '<div class="item" data-name="{{item.curationName}}">'+
            '<a href="{{MKTF30021.getUrl().questionList + item.curationId}}">'+
                '<div class="img">'+
                '<img src="" data-pc-src="{{item.pcThumbnail}}" data-m-src="{{item.mobileThumbnail}}"  alt="{{vcui.detect.isMobile ? item.mobileThumbnailAltText : item.pcThumbnailAltText}}">'+
                /*
                '{{#if vcui.detect.isMobile}}'+
                    '<img src="{{item.mobileThumbnail}}" alt="{{item.mobileThumbnailAltText}}" class="mo-only">'+
                '{{#else}}'+
                    '<img src="{{item.pcThumbnail}}" alt="{{item.pcThumbnailAltText}}" class="pc-only">'+
                '{{/if}}'+
                */
                '</div>'+
                '<div class="txt-box">'+
                    '{{#if item.curationName != null && item.curationName != ""}}'+
                    '<p class="job">{{item.curationName}}</p>'+
                    '{{/if}}'+
                    '<p class="title">'+
                        '{{#raw item.curationTitle}}'+
                    '</p>'+
                    '<ul class="tag-list" data-curation-tag="{{item.curationTag}}">'+
                    '</ul>'+
                '</div>'+
            '</a>'+
        '</div>'+
    '{{/each}}';
   
	var MKTF30021 = {
        publUrl:{
            jsonLifeStyleList :'/lg5-common/data-ajax/gram/lifeList.json',
            questionList :'/html/GRC/MKTF30022.html?curationId=',  
            find:'#find'
        },
        url:{
            jsonLifeStyleList : '/mkt/api/gram/retrieveGramCurationQuestion.lgajax',
            questionList :'/gram/persona-list?curationId=',
            find:'/gram/find'
        },
		init: function(){
			var self = this;
            self.$footer = $('footer');
            self.$el = $('.MKTF30021');
            self.$addTmplLife = self.$el.find('.recommend-reult-wrap .items');
            self.$btnBnr = self.$el.find('.recommend-reult-wrap .items .item.banner a');
            self.$btnBnr.attr('href',self.getUrl().find);
            lgkorUI.showLoading();
            self.requestData(self.getUrl().jsonLifeStyleList, {}, function(result){
                lgkorUI.showLoading();
                var lists = vcui.template(MKTF30021_tmpl, result.data[0]);
                self.$addTmplLife.find('.item.banner').addClass('mo-only');
                var htmlBnr = self.$addTmplLife.find('.item.banner')[0].outerHTML;
                self.$addTmplLife.html(lists+htmlBnr);

                if(self.$addTmplLife.vcLazyLoaderSwitch){
                    self.$addTmplLife.vcLazyLoaderSwitch();
                }else{
                    vcui.require([
                        'ui/lazyLoaderSwitch',
                    ], function () {
                        self.$addTmplLife.vcLazyLoaderSwitch();
                    });
                }
                $('[data-curation-tag]').each(function(i,el){
                    curationTags = String($(el).attr('data-curation-tag'));
                    curationTags = curationTags.split('#')
                    html = '';
                    for(var i=0; i<curationTags.length; i++){
                        if(curationTags[i]){
                            html += '<li>#'+curationTags[i]+'</li>'
                        }
                    }
                    $(el).html(html);
                })
                self.bindEvents();
                setTimeout(function(){
                    self.$addTmplLife.css('visibility','visible');
                    self.$footer.css('visibility','visible');
                    lgkorUI.hideLoading();
                },1000);
            });
		},
        getUrl : function(){
            var self = this;
            if(window.location.href.indexOf('localhost') > -1 || window.location.href.indexOf('wwwdev50') > -1 || window.location.href.indexOf(':3010') > -1){
                return self.publUrl;
            }else{
                return self.url;
            }
        },
		bindEvents: function() {
			var self = this;
            //업셀링 제품추천 > TABS
            self.$addTmplProductUpTabs && self.$addTmplProductUpTabs.find('a').on('click', function(e){
                e.preventDefault();
                setTimeout(function(){
                    self.moveTabContents();
                },20);
            });
		},
        requestData: function(_json, _post, _func) {
            var self = this;
            var ajaxUrl = _json;
            var postData = _post;
            lgkorUI.requestAjaxDataPost(ajaxUrl, postData, function(result){
                _func(result);
            });
        },
	};
	$(document).ready(function(){
		if(!document.querySelector('.MKTF30021')) return false;
		$('.MKTF30021').buildCommonUI();
        window['MKTF30021'] = MKTF30021;
		MKTF30021.init();
	});
})();